export default __webpack_public_path__ + "static/media/NgoziNdukwe.ace5c884.svg";